import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import moment from "moment";
import {
  FaCalendarAlt,
  FaChartBar,
  FaClipboardList,
  FaDollarSign,
  FaLine,
  FaSnapchatSquare,
  FaTelegramPlane,
} from "react-icons/fa";
import { format_number } from "../../../utilities/ext-function";
import { IoLogoWhatsapp } from "react-icons/io";
import ReportTableTargetReport from "./reportTableTargetReport";
import ReportTableTarget from "./reportTableTarget";

const ModalReport = ({ show, handleClose, data, type, onDeleteChange }) => {
  const [activeTab, setActiveTab] = useState("broadcastSchedule");
  const [selectedData, setSelectedData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const getChannelIcon = (channel) => {
    switch (channel.toLowerCase()) {
      case "whatsapp":
        return (
          <IoLogoWhatsapp
            style={{ color: "#25D366", marginTop: "-2px" }}
            size={18}
          />
        );
      case "telegram":
        return <FaTelegramPlane style={{ color: "#0088cc" }} size={16} />;
      case "line":
        return <FaLine style={{ color: "#00C300" }} size={16} />;
      case "snapchat":
        return <FaSnapchatSquare style={{ color: "#FFFC00" }} size={16} />;
      default:
        return null;
    }
  };

  const getChannelColor = (channel) => {
    switch (channel.toLowerCase()) {
      case "whatsapp":
        return "#25D366"; // Hijau WhatsApp
      case "telegram":
        return "#0088cc"; // Biru Telegram
      case "line":
        return "#00C300"; // Hijau Line
      case "snapchat":
        return "#FFFC00"; // Kuning Snapchat
      default:
        return "#6B7280"; // Default abu-abu
    }
  };

  const scheduleOptions = {
    1: [
      { value: 0, label: "Sunday" },
      { value: 1, label: "Monday" },
      { value: 2, label: "Tuesday" },
      { value: 3, label: "Wednesday" },
      { value: 4, label: "Thursday" },
      { value: 5, label: "Friday" },
      { value: 6, label: "Saturday" },
    ],
    2: Array.from({ length: 31 }, (_, i) => ({
      value: (i + 1).toString(),
      label: (i + 1).toString(),
    })),
  };

  const scheduleRepetitions = [
    { value: 0, label: "Every Day" },
    { value: 1, label: "Every Specified Day" },
    { value: 2, label: "Every Specified Date" },
    {
      value: 3,
      label: "Every Specified Date and Month",
    },
    { value: 4, label: "Every End of Month" },
    { value: 5, label: "Every End of Year" },
  ];

  const formatTime = (time) => {
    let formattedTime = moment(time, "HH:mm:ss").format("hh:mm A");

    // Ganti "12 AM" menjadi "00 AM"
    if (formattedTime.startsWith("12") && formattedTime.includes("AM")) {
      formattedTime = formattedTime.replace("12", "00");
    }

    return formattedTime;
  };

  useEffect(() => {
    if (show) {
      setSelectedData(data);
    }
  }, [show]);

  const handleSubmit = () => {
    onDeleteChange(selectedData); // Update ke parent
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Broadcast Report & Analyze</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Search Bar */}
        <div className="row">
          {/* Informasi selectedData - 1/3 width di layar md ke atas */}
          <div className="col-md-5 mb-3">
            <div className="text-black">
              <p className="fs-4 fw-bold mb-0">{selectedData?.name}</p>
              {selectedData && (
                <p
                  className="fs-16 fw-bold mb-0 flex items-center gap-2"
                  style={{ color: getChannelColor(selectedData.channel) }}
                >
                  {getChannelIcon(selectedData.channel)} {selectedData.channel}
                </p>
              )}
              <p>
                Created at{" "}
                {moment(selectedData?.ts_created).format("DD-MM-YYYY")}
              </p>
            </div>
          </div>

          {/* Kartu statistik - 2/3 width di layar md ke atas */}
          <div className="col-md-7">
            <div className="row g-2">
              {/* Kartu status pengiriman */}
              <div className="col-6 col-lg-3">
                <div className="card shadow-sm mb-2">
                  <div className="card-body border border-gray-300 rounded-lg py-2 px-3">
                    <p className="text-primary mb-0">Sent</p>
                    <p className="text-dark mb-0">
                      {format_number(selectedData?.sent_count)} Contact
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3">
                <div className="card shadow-sm mb-2">
                  <div className="card-body border border-gray-300 rounded-lg py-2 px-3">
                    <p className="text-warning mb-0">Delivered</p>
                    <p className="text-dark mb-0">
                      {format_number(selectedData?.delivered_count)} Contact
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3">
                <div className="card shadow-sm mb-2">
                  <div className="card-body border border-gray-300 rounded-lg py-2 px-3">
                    <p className="text-success mb-0">Read</p>
                    <p className="text-dark mb-0">
                      {format_number(selectedData?.read_count)} Contact
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3">
                <div className="card shadow-sm mb-2">
                  <div className="card-body border border-gray-300 rounded-lg py-2 px-3">
                    <p className="text-danger mb-0">Failed</p>
                    <p className="text-dark mb-0">
                      {format_number(selectedData?.failed_count)} Contact
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Kartu kategori sentimen */}
            <div className="row g-2">
              <div className="col-6 col-lg-3">
                <div className="card shadow-sm mb-2">
                  <div className="card-body bg-success text-light border border-gray-300 rounded-lg py-2 px-3">
                    <p className="mb-0">Positive</p>
                    <p className="mb-0">
                      {format_number(selectedData?.positive_count)} Contact
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3">
                <div className="card shadow-sm mb-2">
                  <div className="card-body bg-primary text-light border border-gray-300 rounded-lg py-2 px-3">
                    <p className="mb-0">Neutral</p>
                    <p className="mb-0">
                      {format_number(selectedData?.neutral_count)} Contact
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3">
                <div className="card shadow-sm mb-2">
                  <div className="card-body bg-danger text-light border border-gray-300 rounded-lg py-2 px-3">
                    <p className="mb-0">Negative</p>
                    <p className="mb-0">
                      {format_number(selectedData?.negative_count)} Contact
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-6 col-lg-3">
                <div className="card shadow-sm mb-2">
                  <div className="card-body bg-warning text-light border border-gray-300 rounded-lg py-2 px-3">
                    <p className="mb-0">Need Follow Up</p>
                    <p className="mb-0">
                      {format_number(selectedData?.need_follow_up_count)}{" "}
                      Contact
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            {/* Nav Tabs */}
            <ul className="nav nav-tabs mt-5">
              <li className="nav-item text-center">
                <a
                  className={`nav-link ${
                    activeTab === "broadcastSchedule" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("broadcastSchedule")}
                >
                  <FaCalendarAlt className="mt-1 mb-1" size={20} /> <br />{" "}
                  Broadcast Schedule
                </a>
              </li>
              <li className="nav-item text-center">
                <a
                  className={`nav-link ${
                    activeTab === "broadcastTarget" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("broadcastTarget")}
                >
                  <FaClipboardList className="mt-1 mb-1" size={20} /> <br />{" "}
                  Broadcast Target
                </a>
              </li>
              <li className="nav-item text-center">
                <a
                  className={`nav-link ${
                    activeTab === "broadcastReport" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("broadcastReport")}
                >
                  <FaChartBar className="mt-1 mb-1" size={20} /> <br />{" "}
                  Broadcast Report
                </a>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content mt-3">
              {activeTab === "broadcastSchedule" && (
                <div className="tab-pane fade show active">
                  <div className="table-responsive">
                    <table className="table table-bordered table-bordered table-custome">
                      <thead>
                        <tr className="text-white">
                          <th rowSpan="2" className="text-center p-2">
                            Schedule Repetition
                          </th>
                          <th
                            rowSpan="2"
                            className="text-center p-2"
                            style={{ width: "15%" }}
                          >
                            Schedule Setting
                          </th>
                          <th colSpan="2" className="text-center p-2">
                            Daily Operational Hour
                          </th>
                          <th colSpan="2" className="text-center p-2">
                            Campaign Period
                          </th>
                        </tr>
                        <tr className="text-white">
                          <th className="text-center p-2">Start Hour</th>
                          <th className="text-center p-2">End Hour</th>
                          <th className="text-center p-2">Start Date</th>
                          <th className="text-center p-2">End Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedData &&
                          selectedData.schedule.map((row, index) => (
                            <tr key={index}>
                              {/* Schedule Repetition */}
                              <td className="p-2">
                                {
                                  scheduleRepetitions[row.schedule_repetition]
                                    .label
                                }
                              </td>
                              <td className="p-2">
                                {row.schedule_setting
                                  ? scheduleOptions[row.schedule_repetition]
                                      .label
                                  : row.schedule_repetition === 3
                                  ? moment(row.schedule_setting_ddmm).format(
                                      "DD-MM-YYYY"
                                    )
                                  : "-"}
                              </td>
                              <td className="p-2 text-center">
                                {row.hour_start
                                  ? formatTime(row.hour_start)
                                  : "-"}
                              </td>
                              <td className="p-2 text-center">
                                {row.hour_end ? formatTime(row.hour_end) : "-"}
                              </td>
                              <td className="p-2 text-center">
                                {row.date_start
                                  ? moment(row.date_start).format("DD-MM-YYYY")
                                  : "-"}
                              </td>
                              <td className="p-2 text-center">
                                {row.date_end
                                  ? moment(row.date_end).format("DD-MM-YYYY")
                                  : "-"}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {activeTab === "broadcastTarget" && (
                <div className="tab-pane fade show active">
                  <ReportTableTarget selectedData={selectedData} />
                </div>
              )}
              {activeTab === "broadcastReport" && (
                <div className="tab-pane fade show active">
                  <ReportTableTargetReport selectedData={selectedData} />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Tabel Data */}
        {/* <table className="table table-striped table-bordered table-custome w-100">
          <thead>
            <tr className="text-white">
              <th className="p-2">First Name</th>
              <th className="p-2">Last Name</th>
              <th className="p-2">Title</th>
              <th className="p-2">MSISDN</th>
              <th className="p-2">Email</th>
              <th className="p-2">Address</th>
              <th className="p-2">Group</th>
              {type === "contacts" && (
                <th className="p-2 text-center">Actions</th>
              )}
            </tr>
          </thead>
          <tbody></tbody>
        </table> */}
      </Modal.Body>
    </Modal>
  );
};

export default ModalReport;
